import type { FC, ReactNode } from 'react'

import { MaskMark } from '@/components/generals/mask-mark'
import { NAV_LINKS, siteConfig } from '@/constants/site'

export const SiteFooter: FC = (): ReactNode => {
    return (
        <footer id='site-footer' className='border-t border-border bg-card/40'>
            <div className='mx-auto flex max-w-7xl flex-col gap-10 px-5 py-14 sm:px-8 md:flex-row md:items-start md:justify-between'>
                <div className='max-w-sm space-y-4'>
                    <a
                        href='#stage'
                        className='inline-flex items-center gap-2.5 rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
                    >
                        <MaskMark className='size-8' />
                        <span className='font-heading text-2xl font-bold'>
                            {siteConfig.name}
                        </span>
                    </a>

                    <p className='text-sm leading-relaxed text-muted-foreground'>
                        סטודיו למשחק ותיאטרון לילדים ולנוער. מקום לשחק, להעז, ליצור ולגלות את הקול שלכם.
                    </p>
                </div>

                <nav aria-label='ניווט תחתון'>
                    <ul className='grid grid-cols-2 gap-x-10 gap-y-3 text-sm'>
                        {NAV_LINKS.map((link) => (
                            <li key={link.href}>
                                <a
                                    href={link.href}
                                    className='text-foreground/75 transition-colors duration-300 hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>

            <div className='border-t border-border'>
                <p className='mx-auto max-w-7xl px-5 py-5 text-xs text-muted-foreground sm:px-8'>
                    ©{' '}
                    <span suppressHydrationWarning>
                        {new Date().getFullYear()}
                    </span>
                    {' '}
                    {siteConfig.name}
                </p>
            </div>
        </footer>
    )
}
